import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoricalSvgComponent } from './historical-svg.component';

@NgModule({
  declarations: [
    HistoricalSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    HistoricalSvgComponent
  ]
})
export class HistoricalSvgModule { }
